import React from "react";
import Modal from "react-bootstrap/Modal";
import { getIconCSSClass } from "../../utils/index";

export default function ImageLinkMobile({
  id,
  createNonInternalStream,
  tabindex,
  linkImage,
  setModalIsOpen,
  modalIsOpen,
  children,
  title,
}) {
  const toggle = () => setModalIsOpen(!modalIsOpen);
  return (
    <>
      <a
        id={`action-point-${id}`}
        title={title}
        onClick={() => {
          toggle();
          createNonInternalStream();
        }}
        tabindex={tabindex}
      >
        {children}
      </a>
      <Modal centered show={modalIsOpen} onHide={toggle}  className="break-sizing modal-action-point-mobile">
        <div className="modal-custom modal-action-point-mobile">
          <div onClick={toggle} className="modal-custom__close">
            <div className="modal-custom__close-inner h-100 d-flex justify-content-center align-items-center">
              &#10005;
            </div>
          </div>
          <div className="modal-custom__body">
            <div className="modal-actionpoint-container text-center">
              <img src={linkImage} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
